import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.auth.login');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-auth-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.auth.login/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}`],
})
export class PortalAuthLoginComponent implements OnInit {
    @Input() redirectUrl: string = '/';
    @Input() showRegister: boolean = true;

    public data: any = { email: '', password: '' };
    public loading: boolean = false;
    public view: string = 'login';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public async login() {
        if (!this.data.email) {
            await this.service.modal.error("이메일을 입력해주세요.");
            return;
        }
        if (!this.data.password) {
            await this.service.modal.error("비밀번호를 입력해주세요.");
            return;
        }

        this.loading = true;
        await this.service.render();

        const formData = new URLSearchParams();
        formData.append('email', this.data.email);
        formData.append('password', this.data.password);

        try {
            const response = await fetch('/api/auth/login', {
                method: 'POST',
                body: formData
            });
            const result = await response.json();

            if (response.ok) {
                location.href = this.redirectUrl;
            } else {
                await this.service.modal.error(result.message || "로그인에 실패했습니다.");
            }
        } catch (e) {
            await this.service.modal.error("서버 오류가 발생했습니다.");
        }

        this.loading = false;
        await this.service.render();
    }
}

export default PortalAuthLoginComponent;